import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { AccordionContext } from '../utils/constants.js';
import { jsx } from 'react/jsx-runtime';

const AccordionProvider = props => /*#__PURE__*/jsx(AccordionContext.Provider, _extends({}, props));

export { AccordionProvider };
